import { StepKey, StepMap, ValidationPerStep } from './LongTermWorkflow.types';
import { WHO_IS_FOR, WhoIsThisAccountFor } from '../Steps/WhoIsThisAccountFor/WhoIsThisAccountFor';
import { BIRTH_DATE, YourDateOfBirth } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import {
  PARTNER_BIRTH_DATE,
  PARTNER_FIRST_NAME,
  PARTNER_LAST_NAME,
  PartnerData,
} from '../Steps/PartnerData/PartnerData';
import {
  TOTAL_INVESTABLE_ASSETS,
  TotalValueInvestableAssets,
} from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';
import {
  HOW_MUCH_SAVED,
  HowMuchSavePerMonth,
} from '../Steps/HowMuchSavePerMonth/HowMuchSavePerMonth';
import { WhoIsForOptionsDTO } from '../../api/useAutomatedAccountsQuery';

export const FIELD_NAME = {
  [WHO_IS_FOR]: WHO_IS_FOR,
  [BIRTH_DATE]: BIRTH_DATE,
  [PARTNER_FIRST_NAME]: PARTNER_FIRST_NAME,
  [PARTNER_LAST_NAME]: PARTNER_LAST_NAME,
  [PARTNER_BIRTH_DATE]: PARTNER_BIRTH_DATE,
  [TOTAL_INVESTABLE_ASSETS]: TOTAL_INVESTABLE_ASSETS,
  [HOW_MUCH_SAVED]: HOW_MUCH_SAVED,
};

export const DEFAULT_VALUES = {
  [FIELD_NAME.whoIsFor]: null,
  [FIELD_NAME.birthDate]: '',
  [FIELD_NAME.partnerFirstName]: '',
  [FIELD_NAME.partnerLastName]: '',
  [FIELD_NAME.partnerBirthDate]: '',
  [FIELD_NAME.totalInvestableAssets]: null,
  [FIELD_NAME.howMuchSaved]: null,
};

export const VALIDATION_PER_STEP = {
  [StepKey.Birthday]: [FIELD_NAME.birthDate],
  [StepKey.Partner]: [
    FIELD_NAME.partnerFirstName,
    FIELD_NAME.partnerLastName,
    FIELD_NAME.partnerBirthDate,
  ],
  [StepKey.TotalValue]: [FIELD_NAME.totalInvestableAssets],
  [StepKey.HowMuchSaved]: [FIELD_NAME.howMuchSaved],
} as ValidationPerStep;

export const STEPS_MAP = {
  [StepKey.WhoIsFor]: () => WhoIsThisAccountFor,
  [StepKey.Birthday]: () => YourDateOfBirth,
  [StepKey.Partner]: ({ whoIsFor = null }) =>
    whoIsFor && whoIsFor === WhoIsForOptionsDTO.Single ? null : PartnerData,
  [StepKey.TotalValue]: () => TotalValueInvestableAssets,
  [StepKey.HowMuchSaved]: () => HowMuchSavePerMonth,
} as StepMap;
